import { GraftConfig as RegionalUsersGraftConfig } from '@graft/nuget-gc.webportals.regionalusers'
import { GraftConfig as UsersGraftConfig } from '@graft/nuget-gc.webportals.users'

import { readGraftWebserviceUrl } from '@common/core/config/utils/read-graft-webservice-url.util'

const usersUrl = readGraftWebserviceUrl('USERS')
const regionalUsersUrl = readGraftWebserviceUrl('REGUSERS')

if (usersUrl) {
  UsersGraftConfig.host = usersUrl
  UsersGraftConfig.stateless = true
}

if (regionalUsersUrl) {
  RegionalUsersGraftConfig.host = regionalUsersUrl
  RegionalUsersGraftConfig.stateless = true
}
